import React from 'react';

const roles = [
  {
    title: 'Business Development Officer',
    type: 'Operations',
    description:
      'Area-based provider relationship management, escalation awareness, onboarding support, and local growth.',
  },
  {
    title: 'Audit and Disputes Lead',
    type: 'Governance',
    description:
      'Structured handling of disputes, escalation support, audit tracking, and operational trust processes.',
  },
  {
    title: 'Customer Support and Success',
    type: 'Support',
    description:
      'Customer help, provider communication, issue handling, and experience quality improvement.',
  },
  {
    title: 'Product and Platform',
    type: 'Product',
    description:
      'Frontend, backend, workflow, and module design across discovery, booking, AI, and provider operations.',
  },
  {
    title: 'AI and Experience',
    type: 'Innovation',
    description:
      'Future AI preview flows, recommendation logic, and customer-facing experimentation design.',
  },
  {
    title: 'Finance and Compliance',
    type: 'Control',
    description:
      'Pricing logic, payment transparency, subscription controls, governance, and compliance-aware operations.',
  },
];

export default function CareersPage() {
  return (
    <main style={{ background: '#f8fafc', color: '#0f172a', minHeight: '100vh' }}>
      <section
        style={{
          padding: '72px 24px 56px',
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
          }}
        >
          <p
            style={{
              margin: 0,
              color: '#4f46e5',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              fontSize: '0.9rem',
            }}
          >
            Careers
          </p>
          <h1 style={{ margin: 0, fontSize: '3rem', lineHeight: 1.08, maxWidth: '12ch' }}>
            Join the team shaping the HnB platform
          </h1>
          <p
            style={{
              margin: 0,
              color: '#475569',
              lineHeight: 1.8,
              fontSize: '1.05rem',
              maxWidth: '72ch',
            }}
          >
            Your earlier HnB planning explicitly anticipated public careers visibility
            for roles across business development, audit, support, product, and engineering,
            so this page should present HnB as a growing platform organisation rather than
            a simple app shell.
          </p>
        </div>
      </section>

      <section style={{ padding: '56px 24px' }}>
        <div
          style={{
            maxWidth: '1080px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '18px',
          }}
        >
          {roles.map((role) => (
            <div
              key={role.title}
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '18px',
                padding: '22px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <span
                style={{
                  alignSelf: 'flex-start',
                  padding: '7px 10px',
                  borderRadius: '999px',
                  background: '#eef2ff',
                  color: '#4338ca',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                }}
              >
                {role.type}
              </span>
              <h2 style={{ margin: 0, fontSize: '1.1rem' }}>{role.title}</h2>
              <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.75 }}>
                {role.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          padding: '56px 24px 72px',
          background: '#ffffff',
          borderTop: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '900px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          <h2 style={{ margin: 0, fontSize: '2rem' }}>Apply your interest</h2>
          <p style={{ margin: 0, color: '#64748b', lineHeight: 1.8 }}>
            At this stage, the careers page can start with an expression-of-interest
            model rather than a fully dynamic recruitment system. You can later connect
            this to a real application workflow, ATS, or internal HnB hiring dashboard.
          </p>

          <div
            style={{
              background: '#f8fafc',
              border: '1px solid #e5e7eb',
              borderRadius: '18px',
              padding: '22px',
              display: 'flex',
              flexDirection: 'column',
              gap: '14px',
            }}
          >
            <input
              type="text"
              placeholder="Full name"
              style={{
                padding: '12px 14px',
                borderRadius: '10px',
                border: '1px solid #d1d5db',
              }}
            />
            <input
              type="email"
              placeholder="Email address"
              style={{
                padding: '12px 14px',
                borderRadius: '10px',
                border: '1px solid #d1d5db',
              }}
            />
            <select
              style={{
                padding: '12px 14px',
                borderRadius: '10px',
                border: '1px solid #d1d5db',
                background: '#ffffff',
              }}
            >
              <option>Select role area</option>
              <option>Business development</option>
              <option>Audit and disputes</option>
              <option>Customer support</option>
              <option>Product and engineering</option>
              <option>Finance and compliance</option>
            </select>
            <textarea
              rows={5}
              placeholder="Tell us about your background"
              style={{
                padding: '12px 14px',
                borderRadius: '10px',
                border: '1px solid #d1d5db',
                resize: 'vertical',
              }}
            />
            <button
              type="button"
              style={{
                background: '#111827',
                color: '#ffffff',
                border: 'none',
                padding: '13px 18px',
                borderRadius: '10px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Submit interest
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}